export default __webpack_public_path__ + "static/media/future-here.d069625d.png";